import { useCallback, useEffect, useState } from "react";
import Card from "./modules/Card";
import { pages } from "./data";
export const useTest = () => {
  const [points, setPoints] = useState({});
  const [page, setPage] = useState(0);
  const [final, setFinal] = useState(false);
  const [last, setLast] = useState(false);
  const [answered, setAnswered] = useState(false);

  const assignPoint = (page, value) => {
    setPoints({ ...points, [page]: value });
    setAnswered(true);
  };

  const navigate = useCallback(() => {
    setAnswered(false);
    if (last) {
      setFinal(createFinal(points));
      return;
    }
    setPage((prev) => prev + 1);
  });

  useEffect(() => {
    if (page + 1 === 3 || page + 1 === 6 || page + 1 === 8) {
      setAnswered(true);
    }
    if (page + 1 === Object.keys(pages).length) {
      setLast(true);
    } else {
      setLast(false);
    }
  }, [page]);

  const renderCard = () => {
    return (
      <Card
        navigate={navigate}
        assignPoint={assignPoint}
        details={pages[page]}
        final={final}
        answered={answered}
        last={last}
        page={page}
      />
    );
  };

  return {
    renderCard,
    page,
  };
};

function createFinal(points) {
  let score = Object.values(points).reduce((a, i) => a + +i, 0);

  let result = false;
  if (score === 0) {
    result = {
      text: "Прекрасно, что вас заинтересовала тема переработки щёток. Здесь вы можете прочитать подробности и результаты акции и понять, почему это так важно.",
      badge: "newbie",
      title: "Первооткрыватель",
    };
  } else if (score === 1) {
    result = {
      text: "Вы что-то уже знаете о переработке щёток. Рады, что вы здесь и узнали об этом больше!",
      badge: "sympathetic",
      title: "Сочувствующий",
    };
  } else if (score === 2) {
    result = {
      text: "Мы рады, что для вас важна забота об окружающей среде! Надеемся, вы уже участвовали в нашей акции.",
      badge: "friend",
      title: "Новый друг по переработке",
    };
  } else if (score === 3) {
    result = {
      text: "Вы понимаете суть акции и, возможно, уже сдавали щётки на переработку. Спасибо, что заботитесь о природе и поддерживаете нас!",
      badge: "eco-expert",
      title: "Экознаток",
    };
  } else if (score === 4) {
    result = {
      text: "Вы разбираетесь в переработке сможете подробно объяснить, для чего это всё. Будем благодарны, если расскажете об акции вашим знакомым.",
      badge: "expert",
      title: "Эксперт",
    };
  } else {
    result = {
      text: "Вы понимаете, какая польза от переработки щёток и знаете подробности акции. Здорово, что вы так внимательно относитесь к окружающей среде. Вдохновите своим примером окружающих — расскажите об акции!",
      badge: "sensei",
      title: "Сенсей",
    };
  }
  return result;
}
